
    <form #paymentForm="ngForm" name="paymentForm" (ngSubmit)="forward(paymentForm)"
        novalidate autocomplete="off" appScrollToInvalid
        [ngClass]="{'form-complete': isFormCompleted}">
        <div *ngFor="let ccerror of CCerrors">{{ccerror}}</div>

        <section class="card" name="hotelFee" *ngIf="charges.Hotel > 0">
            <div class="card-header">
                <div class="card-title">
                    {{ 'copy.label.PAYMENT.FEESRT10.hotel' | copy | async }} {{charges.Hotel | currency}}
                </div>
            </div>
            <article>
                <div class="card-body w-100">
                    <div [innerHTML]='"copy.html.OtherPayment" | copy | async'></div>
                    <app-collect-payment cardType="Hotel" [ccOnly]="true"></app-collect-payment>
                </div>
            </article>
        </section>

        <section class="card" name="hotelFee">
            <div class="card-header">
                <div class="card-title">
                    {{ 'copy.label.PAYMENT.FEESRT10.hotelguarantee' | copy | async }}
                </div>
            </div>
            <article>
                <div class="card-body w-100">
                    <div [innerHTML]='"copy.html.HotelGuaranteeText"|copy|async'></div>
                    <app-collect-payment cardType="Hotel" [ccOnly]="true"></app-collect-payment>
                </div>
            </article>
        </section>



    </form>
